const __request = require(`./__request`);
/**
 * 授信账号信息
 */
export default function(val){
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/credit/creditAccountDetail"
    pParameter.data = val
    return new Promise(function(resolve, reject){
        resolve(__request(pParameter))
    })
}
